import * as  action from './action'

class System {
    set(payload){
        return {
            type: action.SET_SYSTEM,
            payload: payload
        };
    }
}

export default new System();



// WEBPACK FOOTER //
// ./redux/model/system/model.js